<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-23T10:40:29+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe
@Last modified by:   tom
@Last modified time: 2019-06-08T15:46:39+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
// update automatically header needed
-->

<template lang="html">
  <div id="landing">

    <!-- Logo -->
    <section id="logo" class="pb-2">
      <b-container>

        <b-row class="offset-md-4 col-md-4 mb-4">
          <!-- wide screen logo margins -->
          <b-img-lazy :alt="$t('title.alt')" class="main-logo d-none d-sm-block mt-4" src="@/assets/img/logo/Qrespi-Logo-m.svg" height="140"/>
          <!-- small screen no margins -->
          <b-img-lazy :alt="$t('title.alt')" class="main-logo d-block d-sm-none" src="@/assets/img/logo/Qrespi-Logo-m.svg" height="80" />
        </b-row>
        <b-row id="changing-world" align-v="center">
          <b-col>
            <typewriter :out="$t('title.subtitle')" once class="mx-auto" />
          </b-col>
        </b-row>
        <p id="subtext" class="header mt-2 pt-2 pb-0 mx-auto text-primary" v-html="$t('intro.1.payload')"/>

      </b-container>
    </section>

    <intro/>
    <testimonial/>
    <solutions/>
    <contact/>
    <navbottom/>

  </div>
</template>

<script>
import Vue from 'vue'

import invokeScrollEvent from '@/components/_shared/invokeScrollEvent'

// import the homepage = landing page components immediately visible
import Intro from '@/components/home/Intro'
import Testimonial from '@/components/home/Testimonial'
import SolutionsSlider from '@/components/home/SolutionsSlider'
import Contact from /* webpackChunkName: "contact" */'@/components/home/Contact'

Vue.component('intro', Intro)
Vue.component('testimonial', Testimonial)
Vue.component('solutions', SolutionsSlider)
Vue.component('contact', Contact)

export default {
  mounted: function () {
    // Code that will run only after the entire view has been re-rendered
    invokeScrollEvent('Home Page mounted')
  }
}

</script>

<style lang="scss">

  #landing {
    .main-logo {
      // important for IE10 (!)
      width: 100%;
    }
    #changing-world {
      color: $secondary;
    //  border-top: $secondary 1px solid;
      .typewriter {
        border-bottom: #ddd 1px solid;
      }
      padding: 0 10px;
      background: linear-gradient(to bottom, rgba(255,255,255,0.5) 0%,rgba(255,255,255,.95) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
//      background-color: $primaryWhite;
      height: 3em;
      @media (max-width: 600px) {
        height: 6em;
      }
    }
    #subtext {
      background: linear-gradient(to bottom, rgba(255,255,255,0.4) 0%,rgba(255,255,255,.9) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    }
  }
  #subtitle {
    font-size: 1.4em;
  }

  @media (min-width: 600px) {
    #landing {
      background: $primaryWhite no-repeat fixed;
      // background-image: url('img/landing/top-people-tr.png');
      background-position: center 80px;
      // #changing-world {
      //   // height: 6em;
      // }
    }
  }
  // @media (min-width: 1200px) {
  //   #landing {
  //     #changing-world {
  //       // height: 4em;
  //     }
  //   }
  // }

</style>
